import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    currentWindow: '',
    videoData: "",
    kkData: '',
    jzrd: '',
    arData: '',
    faceData: '',
    keyData: '',
    spaceQuery: false,
    cxjg:'',
    cxjgObject:{}
  },
  getters: {
    getSpaceQuery(state) {
      return state.spaceQuery
    },
    getcxjg(state){
        return state.cxjg
    }
  },
  mutations: {
    switchWindow(state, value) {
      state.currentWindow = value
    },
    videoData(state, value) {
      state.videoData = value
    },
    kkData(state, value) {
      state.kkData = value
    },
    jzrdData(state, value) {
      state.jzrdData = value
    },
    arData(state, value) {
      state.arData = value
    },
    faceData(state, value) {
      state.faceData = value
    },
    keyData(state, value) {
      state.keyData = value
    },
    setSpaceQuery(state, value) {
      state.spaceQuery = value
    },
    setcxjg(state,value){
        state.cxjg=value
        window.sessionStorage.setItem("cxjgObject",JSON.stringify(value))
    }
  },
  actions: {

  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js